import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import 'react-dropdown/style.css';
// import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { Oval } from 'react-loader-spinner';
import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Select from 'react-select';
import * as moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MDButton from 'components/MDButton';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import * as service from '../../services/service';

function RejectedOperationReport() {
    const [reportDetailsData, setReportDetailsData] = useState([]);
    const [showDetailsReport, setShowDetailsReport] = useState(false);
    const [customerData, setCustomerData] = useState([]);
    const [customerId, setCustomerId] = useState('');
    const [workOrderData, setWorkOrderData] = useState([]);
    const [workOrderId, setWorkOrderId] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [allocationFor, setAllocationFor] = useState('');
    const allocationForData = [{ label: 'Work Order', value: 'Work Order' }, { label: 'Stock', value: 'Stock' }]
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const userDesignation = JSON.parse(sessionStorage.getItem('userData')).designation;
    const getCustomers = () => {
        fetch(
            service.CUSTOMER_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.customerId, label: item.customerName }));
                // const all = ({ value: "0", label: "All" });
                // data2.unshift(all);
                setCustomerData(data2);
                // setCustomerId(all);
            });
    };
    const getWorkOrders = (id) => {
        fetch(
            service.GET_ALL_WORK_ORDER_NUMBERS,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CustomerId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.workOrderNo, label: item.workOrderNo }));
                // const all = ({ value: "", label: "All" });
                // data2.unshift(all);
                setWorkOrderData(data2);
                // setWorkOrderId(all);
            });
    };
    function GetReport() {
        const errs = {};
        let custId = 0;
        let workOrder = '';
        if (allocationFor.value === "Work Order") {
            custId = customerId ? customerId.value : 0;
            workOrder = workOrderId ? workOrderId.value : ''
        }
        fetch(
            service.GET_REJECTED_OPERATION_REPORT,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    AllocationFor: allocationFor.value,
                    CustomerId: custId,
                    WorkOrderNo: workOrder,
                    FromDate: fromDate ? moment(fromDate).format("MM/DD/YYYY") : null,
                    ToDate: toDate ? moment(toDate).format("MM/DD/YYYY") : null
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.length === 0) {
                    errs[".invalid"] = 'No Data Found!';
                    setErrors(errs);
                    setShowDetailsReport(false);
                }
                else if (result.length > 0 && result[0].message.messageType === 'Success') {
                    setShowDetailsReport(true);
                    setReportDetailsData(result);
                    errs[".invalid"] = '';
                    setErrors(errs);
                }
                else if (result[0].message.messageType === 'Failed') {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowDetailsReport(false);
                }
                else {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowDetailsReport(false);
                }
            });
    }

    useEffect(() => {
        setLoading(true);
        getCustomers();
        setLoading(false);
    }, []);

    const changeHandler = (ev) => {
        setCustomerId(ev);
        getWorkOrders(ev.value);
        setReportDetailsData([]);
    }
    const workOrderchangeHandler = (ev) => {
        setWorkOrderId(ev);
        setReportDetailsData([]);
    }
    const allocationForChangeHandler = (ev) => {
        setAllocationFor(ev);
        setCustomerId(null);
        setWorkOrderId(null);
        setReportDetailsData([]);
    }
    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!allocationFor) {
            isValid = false;
            errs[".allocationFor"] = "Please select allocation for";
        }
        if (allocationFor.value === "Work Order" && !customerId) {
            isValid = false;
            errs[".customer"] = "Please select customer";
        }
        if (allocationFor.value === "Work Order" && !workOrderId) {
            isValid = false;
            errs[".workorder"] = "Please select work order";
        }
        setErrors(errs);
        return isValid;
    }
    const submitHandler = e => {
        setReportDetailsData([]);
        setShowDetailsReport(false);
        e.preventDefault();
        setLoading(true);
        if (validate()) {
            GetReport();
        }
        setLoading(false);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        {userDesignation === 'General Manager' || userDesignation === 'Asst Mgr - Production'
                            || userDesignation === 'Jr Mgr - Production' || userDesignation === 'Manager - Production'
                            || userDesignation === 'Sr Mgr - Production' || userDesignation === 'MD'
                            || userDesignation === 'Bussiness Development and Operations' || userDesignation === 'Jr Mgr - Purchase' 
                            || userDesignation === 'Manager - Purchase' || userDesignation === 'Sr Mgr - Purchase' ?
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="white">
                                        Rejected Operation Report
                                    </MDTypography>
                                </MDBox>
                                <br />
                                <Table aria-label="simple table">
                                    <TableRow>
                                        <TableCell align="right" style={{ fontSize: '12px' }}>
                                            Allocation For :
                                        </TableCell>
                                        <TableCell align="left" style={{ fontSize: '12px' }}>
                                            <Select
                                                options={allocationForData}
                                                name="allocationFor"
                                                value={allocationFor}
                                                onChange={allocationForChangeHandler}
                                                placeholder="Select For"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".allocationFor"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell width="25%" align="right" style={{ fontSize: '12px' }}>
                                            Customer :
                                        </TableCell>
                                        <TableCell width="25%" align="left" style={{ fontSize: '12px' }}>
                                            <Select
                                                options={customerData}
                                                name="customer"
                                                value={customerId}
                                                onChange={changeHandler}
                                                placeholder="Select Customer"
                                                isSearchable
                                                styles={selectStyles}
                                                isDisabled={allocationFor.value === 'Stock'}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".customer"]}</div>
                                        </TableCell>
                                        <TableCell width="25%" align="right" style={{ fontSize: '12px' }}>
                                            Work Order :
                                        </TableCell>
                                        <TableCell align="left" style={{ fontSize: '12px' }}>
                                            <Select
                                                options={workOrderData}
                                                name="workOrderId"
                                                value={workOrderId}
                                                onChange={workOrderchangeHandler}
                                                placeholder="Select Work Order"
                                                isSearchable
                                                styles={selectStyles}
                                                isDisabled={allocationFor.value === 'Stock'}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".workorder"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="right" style={{ fontSize: '12px' }}>
                                            From Date :
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px' }}>
                                            <DatePicker
                                                id="fromDate"
                                                selected={fromDate}
                                                onChange={date => setFromDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                            />
                                        </TableCell>
                                        <TableCell align="right" style={{ fontSize: '12px' }}>
                                            To Date :
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px' }}>
                                            <DatePicker
                                                id="toDate"
                                                selected={toDate}
                                                onChange={date => setToDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                            />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan="6" align="center">
                                            <MDBox mt={4} mb={1} textAlign="center">
                                                {loading ?
                                                    <Oval
                                                        heigth="20"
                                                        width="20"
                                                        color='grey'
                                                        ariaLabel='loading'
                                                    />
                                                    :
                                                    <MDButton color="info" onClick={submitHandler}>
                                                        Show
                                                    </MDButton>
                                                }
                                                {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                            </MDBox>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                                <Card style={{ alignItems: 'center' }}>
                                    {loading ?
                                        <Oval
                                            heigth="100"
                                            width="100"
                                            color='grey'
                                            ariaLabel='loading'
                                        /> :
                                        <TableContainer component={Paper} style={{ width: '98%', alignSelf: 'center' }}>
                                            <Table id="dvDetailReport">
                                                <TableRow>
                                                    <TableCell colSpan="12" align="center">
                                                        <Table>
                                                            <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                Allocation For : {allocationFor.value}
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                From Date : {fromDate ? moment(fromDate).format("DD/MM/YYYY") : ''}
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                To Date : {toDate ? moment(toDate).format("DD/MM/YYYY") : ''}
                                                            </TableCell>
                                                        </Table>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Customer</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Work Order No.</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Job No.</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Employee</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Product</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Sub Assembly</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Part</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Operation</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Stock No</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Allocation Date</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Planned Completion Date</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Remarks</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Rejection Remarks</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Inspection</TableCell>

                                                </TableRow>
                                                {reportDetailsData.map((row) => (
                                                    <TableRow
                                                        key={row.workAllocationId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell style={{ fontSize: '14px' }}>{row.customerName}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.workOrderNo}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.jobNo}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.employeeName}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.product}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.subAssembly}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.part}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.operation}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.stockNo}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{moment(row.allocationDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{moment(row.plannedCompletionDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.remarks}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.dailyStatusRemarks}</TableCell>
                                                        {row.dailyWorkInspectionObservation && row.dailyWorkInspectionObservation.length ?
                                                            <TableCell>
                                                                <Table>
                                                                    <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Inspection Parameter</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Specification</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>UpperLimit</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>LowerLimit</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Observation</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Remarks</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Status</TableCell>
                                                                    </TableRow>
                                                                    {row.dailyWorkInspectionObservation.map((mat) => (
                                                                        <TableRow>
                                                                            <TableCell style={{ fontSize: '14px' }}>{mat.inspectionParameter}</TableCell>
                                                                            <TableCell style={{ fontSize: '14px' }}>{mat.specification}</TableCell>
                                                                            <TableCell style={{ fontSize: '14px' }}>{mat.upperLimit}</TableCell>
                                                                            <TableCell style={{ fontSize: '14px' }}>{mat.lowerLimit}</TableCell>
                                                                            <TableCell style={{ fontSize: '14px' }}>{mat.observation}</TableCell>
                                                                            <TableCell style={{ fontSize: '14px' }}>{mat.remarks}</TableCell>
                                                                            <TableCell style={{ fontSize: '14px' }}>{mat.status}</TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </Table>
                                                            </TableCell> : <TableCell />
                                                        }
                                                    </TableRow>
                                                ))}
                                            </Table>
                                            <br />
                                            <Table>
                                                <TableRow>
                                                    <TableCell align="center">
                                                        {showDetailsReport ?
                                                            <ReactHTMLTableToExcel table="dvDetailReport" className="info"
                                                                filename="ReportData" sheet="Sheet" buttonText="EXPORT TO EXCEL"
                                                            />
                                                            : null}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>{errors[".invalid"]}</TableCell>
                                                </TableRow>
                                            </Table>
                                        </TableContainer>
                                    }
                                </Card>
                            </Card>
                            :
                            <Card style={{ alignItems: 'center' }}>
                                <div style={{ fontWeight: 'bold', fontSize: '14px', color: 'red' }}>You do not have access to this page</div>
                            </Card>
                        }
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default RejectedOperationReport;
